interface TooltipOptions {
  touchSupport?: boolean;
}

class TooltipManager {
  private tooltips: NodeListOf<HTMLElement>;
  private activeTooltip: HTMLElement | null = null;
  private options: TooltipOptions;

  constructor() {
    this.tooltips = document.querySelectorAll("[data-tooltip]");
    const touchSupport = window.matchMedia("(pointer: coarse)").matches;

    this.options = {
      touchSupport
    };

    this.init();
  }

  private init() {
    if (this.options.touchSupport) {
      // For touch devices
      document.addEventListener("click", (e) => {
        const target = e.target as HTMLElement;
        const tooltip = target.closest("[data-tooltip]") as HTMLElement;

        if (tooltip) {
          e.preventDefault();
          this.toggleTooltip(tooltip);
        } else {
          this.hideActiveTooltip();
        }
      });
    }

    // Close on ESC
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.hideActiveTooltip();
      }
    });
  }

  private toggleTooltip(tooltip: HTMLElement) {
    if (this.activeTooltip === tooltip) {
      this.hideActiveTooltip();
    } else {
      this.hideActiveTooltip();
      tooltip.classList.add("is-active");
      this.activeTooltip = tooltip;
    }
  }

  private hideActiveTooltip() {
    if (this.activeTooltip) {
      this.activeTooltip.classList.remove("is-active");
      this.activeTooltip = null;
    }
  }
}

export const tooltip = {
  init: () => {
    new TooltipManager();
  }
};
